/**
 * resourceCloudUser模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const resourceCloudUser = {
  //分页
  pageResourceCloudUser(params) {
    return $http.post(`${global.API_URL}/sme/resourceCloudUser/page`,params);
  },
  //获取云用户详情
  getCloudUserDetailById(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/resourceCloudUser/getCloudUserDetailById`,param);
  },
  //根据账号和区域查询云用户列表
  listCloudUserByAccount(params) {
    return $http.post(`${global.API_URL}/sme/resourceCloudUser/listCloudUserByAccount`,params);
  },
  //删除
  deleteResourceCloudUser(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/resourceCloudUser/delete`,param);
  }
}

export default resourceCloudUser;



// WEBPACK FOOTER //
// ./src/api/resourceCloudUser.js